import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstAndLastName'
})
export class FirstAndLastNamePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    if (value) {
      let resultado;
      const splitSpaceBar = value[0].split(' ');
      if (typeof splitSpaceBar === 'object' && splitSpaceBar.length > 1) {
        resultado = `${splitSpaceBar[0]} ${splitSpaceBar[splitSpaceBar.length - 1]}`;
      } else if (typeof splitSpaceBar === 'object' && value.length === 1) {
        const splitDot = value[0].split('.');
        if (typeof splitDot === 'object' && splitDot.length > 1) {
          resultado = `${splitDot[0]} ${splitDot[splitDot.length - 1]}`;
        }
      } else if (typeof splitSpaceBar === 'string') {
        const splitDot = value[0].split('.');
        if (typeof splitDot === 'object' && splitDot.length > 1) {
          resultado = `${splitDot[0]} ${splitDot[splitDot.length - 1]}`;
        }
      } else if (typeof value === 'string') {
        const valueSplit = value.split(' ');
        resultado = `${valueSplit[0]} ${valueSplit[valueSplit.length - 1]}`;
      }
      return resultado;
    }

    return null;
  }

}
